exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cell__FinFacturerenModalBody-module___M59yK {\n  width: 215px;\n}\n\n@media (max-width: 525px) {\n  .cell__FinFacturerenModalBody-module___M59yK {\n    width: 150px;\n    font-size: 12px;\n  }\n  .cellText__FinFacturerenModalBody-module___WAYbF {\n    font-size: 12px;\n  }\n}\n", ""]);

// Exports
exports.locals = {
	"cell": "cell__FinFacturerenModalBody-module___M59yK",
	"cellText": "cellText__FinFacturerenModalBody-module___WAYbF"
};